import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';

function CreateChapterModal({ onClose, onCreate, nextChapterNumber }) {
  const [title, setTitle] = useState(`Chapter ${nextChapterNumber}`);
  const [creating, setCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;

    setCreating(true);
    await onCreate({ title, chapter_number: nextChapterNumber });
    setCreating(false);
  };

  return (
    <div className="fixed inset-0 bg-black/45 dark:bg-black/70 flex items-end sm:items-center justify-center p-0 sm:p-4 z-50">
      <div className="bg-[#FBF8F2] dark:bg-[#22201C] rounded-t-[1.5rem] sm:rounded-[1.5rem] shadow-2xl w-full sm:max-w-md border border-[#E8DED0] dark:border-[#2A2520]/70">
        <div className="border-b border-[#E0D8CC] dark:border-[#2A2520]/50 px-4 sm:px-6 py-4 flex items-start justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#9B7D58] dark:text-[#C6A77E] mb-1">Chapter {nextChapterNumber}</p>
            <h2 className="font-serif text-xl font-bold text-[#2A2420] dark:text-[#F0EBE4]">Add New Chapter</h2>
          </div>
          <button onClick={onClose} className="text-[#2A2420] dark:text-[#F0EBE4] hover:text-[#2A2420] p-2">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-4 pb-8">
          <div>
            <label className="block text-sm font-medium text-[#2A2420] dark:text-[#F0EBE4] mb-2">
              Chapter Title
            </label>
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter chapter title"
              data-testid="chapter-title-input"
              className="w-full min-h-[46px] rounded-xl bg-white dark:bg-[#2A2520] dark:text-white dark:border-[#2A2520]"
              required
            />
          </div>

          <div className="bg-white/70 dark:bg-[#2A2520] rounded-xl p-3 text-sm text-[#2A2420]/70 dark:text-[#F0EBE4]/70 border border-[#E8DED0] dark:border-[#2A2520]/70">
            This will be Chapter {nextChapterNumber}
          </div>

          <div className="flex space-x-3 pt-2">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              className="flex-1 min-h-[44px] rounded-full dark:border-[#2A2520] dark:text-[#F0EBE4]"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!title.trim() || creating}
              data-testid="create-chapter-submit"
              className="flex-1 min-h-[44px] rounded-full bg-[#2A2420] hover:bg-[#1A1A1A] dark:bg-[#F8F5F0] dark:hover:bg-white dark:text-[#2A2420] text-[#F5F1E8]"
            >
              {creating ? 'Creating...' : 'Add Chapter'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateChapterModal;
